import { fg } from '@atlassian/jira-feature-gating';

const inlineManageWorkTypesConfigNinIcc = {
	get(): boolean {
		return fg('work_type_inline_config_nin_icc_fg');
	},
};

export default inlineManageWorkTypesConfigNinIcc;
